'use strict';

module.exports = require('./lib')



// WEBPACK FOOTER //
// ./~/promise/index.js